import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import * as sweetalert from 'sweetalert';
import { Sort } from '@angular/material';
import { UUID } from 'angular2-uuid';

//grid
import { AgGridNg2 } from 'ag-grid-angular';



import { TipoMedicionMobile } from '../Models/TipoMedicionMobile';
import { Vehiculo } from '../Models/Vehiculo';


import { GlobalsService } from '../services/globals.service';
import { MedicionService } from '../services/medicion.service';
import { VehiculoService } from '../services/vehiculo.service';

@Component({
  selector: 'app-reporte-medicion-vehiculo',
  templateUrl: './reporte-medicion-vehiculo.component.html',
  styleUrls: ['./reporte-medicion-vehiculo.component.css']
})
export class ReporteMedicionVehiculoComponent implements OnInit {


  public medicionVehiculo: TipoMedicionMobile = new TipoMedicionMobile();
  public medicionVehiculos: TipoMedicionMobile[];

  public vehiculo: Vehiculo = new Vehiculo();
  public vehiculos: Vehiculo[];

  public fechaInicio: Date;
  public fechaFin: Date;

  constructor(private medicionService: MedicionService, private globalServices: GlobalsService, private vehiculoService: VehiculoService) {
  }
  ngOnInit() {

    this.CargarVehiculos();

  }

/**
 * Carga el combo box de vehiculos
 */
  CargarVehiculos() {

    try {

      this.vehiculoService.ObtenerVehiculos(this.globalServices.ObtenerCompania()).subscribe(
        data => {
          this.vehiculos = data;
        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarVehiculos: " + error);
    }
  }

/**
 * Obtiene una lista de mediciones que se va a mostrar en la tabla
 */
  CargarReporteMediciones() {

    try {

      if (this.vehiculo.idvehiculo === undefined || this.vehiculo.idvehiculo === "") {
        this.vehiculo.idvehiculo = null;
      }


      this.medicionService.ObtenerReporteMedicionesVehiculo(this.globalServices.ObtenerCompania(),this.vehiculo.idvehiculo,this.fechaInicio,this.fechaFin).subscribe(
        data => {
          this.medicionVehiculos = data;
        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarVehiculos: " + error);
    }
  }

}

